import { buildApiUrl, getApiBaseUrl } from '../config/api';

const encodeMediaName = (fileName) =>
    String(fileName)
        .replace(/^\/+/, '')
        .split('/')
        .map((part) => encodeURIComponent(part))
        .join('/');

/**
 * Absolute URL for a file under /routes/{kind}/ on the API host.
 * The API serves local files and falls back to the production media CDN when missing.
 */
export function mediaUrl(kind, fileName, { cacheBust = false } = {}) {
    if (!kind || fileName == null || String(fileName).trim() === '') return '';
    const encoded = encodeMediaName(fileName);
    const url = buildApiUrl(`/routes/${kind}/${encoded}`);
    return cacheBust ? `${url}${url.includes('?') ? '&' : '?'}t=${Date.now()}` : url;
}

export function getMediaRoutesBase() {
    return `${getApiBaseUrl().replace(/\/$/, '')}/routes`;
}

export function getSchoolLogoUrl(imageName, opts = {}) {
    return mediaUrl('logothumb', imageName, opts);
}

export function getSchoolLogoFullUrl(imageName, opts = {}) {
    return mediaUrl('logo', imageName, opts);
}

export function getStudentThumbnailUrl(studentOrName, opts = {}) {
    const name =
        typeof studentOrName === 'string' || studentOrName == null
            ? studentOrName
            : studentOrName.image;
    return mediaUrl('thumbnail', name, opts) || null;
}

export function getStudentFullImageUrl(studentOrName, opts = {}) {
    const name =
        typeof studentOrName === 'string' || studentOrName == null
            ? studentOrName
            : studentOrName.image;
    return mediaUrl('uploads', name, opts) || null;
}

export function getStaffThumbnailUrl(staffOrName, opts = {}) {
    return getStudentThumbnailUrl(staffOrName, opts);
}
